module.exports = __webpack_public_path__ + "static/redwood-1-09926c3644aa572fcf972949ed0cdf9a.jpg";